import { useComposeSnapshotIndexStore } from './useComposeSnapshotIndexStore';

export interface SnapshotSyncSettlement {
  draftId?: string;
}

const inFlight = new Map<string, Promise<SnapshotSyncSettlement>>();

// Returns the settle callback; a success carries the real draft id so a waiting open can use it.
export const beginSnapshotSync = (
  sessionId: string,
): ((settlement: SnapshotSyncSettlement) => void) => {
  let resolveGate: (settlement: SnapshotSyncSettlement) => void = () =>
    undefined;
  inFlight.set(
    sessionId,
    new Promise((resolve) => {
      resolveGate = resolve;
    }),
  );
  useComposeSnapshotIndexStore.getState().markSyncing(sessionId);
  return (settlement) => {
    inFlight.delete(sessionId);
    useComposeSnapshotIndexStore.getState().unmarkSyncing(sessionId);
    resolveGate(settlement);
  };
};

export const awaitSnapshotSync = (
  sessionId: string,
): Promise<SnapshotSyncSettlement | undefined> =>
  inFlight.get(sessionId) ?? Promise.resolve(undefined);

export const isSnapshotSyncPending = (sessionId: string): boolean =>
  inFlight.has(sessionId);

export const isSnapshotSyncing = (sessionId: string): boolean =>
  Boolean(useComposeSnapshotIndexStore.getState().syncingSessionIds[sessionId]);
